import React from 'react';

const URL_REGEX = /https?:\/\/[^\s]+|www\.[^\s]+|\b[a-zA-Z0-9-]+\.(com|org|net|io|gg|co|me|dev|app|xyz|info|biz)(\/[^\s]*)?/gi;

export const containsUrl = (text: string): boolean => {
  URL_REGEX.lastIndex = 0;
  return URL_REGEX.test(text);
};

export const linkifyText = (text: string): (string | React.ReactElement)[] => {
  URL_REGEX.lastIndex = 0;
  const parts: (string | React.ReactElement)[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = URL_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const url = match[0];
    const href = url.startsWith('http') ? url : `https://${url}`;
    parts.push(
      React.createElement('a', {
        key: match.index,
        href,
        target: '_blank',
        rel: 'noopener noreferrer',
      }, url)
    );
    lastIndex = URL_REGEX.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? parts : [text];
};
